"use strict";

exports.__esModule = true;
exports.checkIfSelectedCyclesOverstepTime = void 0;
var _vimanaTypes = require("@vimana/vimana-types");
var checkIfSelectedCyclesOverstepTime = exports.checkIfSelectedCyclesOverstepTime = function checkIfSelectedCyclesOverstepTime(cycles, warningClassificationTime) {
  var sumOfAllSelectedCyclesTime = 0;
  cycles.forEach(function (cycle) {
    sumOfAllSelectedCyclesTime += cycle.interval.endMillis - cycle.interval.startMillis;
  });
  return sumOfAllSelectedCyclesTime > warningClassificationTime;
};